<div class="modal-body">
    <div class="modal-close-x" (click)="closeModal()"><fa-icon [icon]="['fas' ,'times']"></fa-icon></div>
    <div class="spacer-sm RenderMath" [innerHTML]="question.QuestionRationale | unsafeHtml"></div>
</div>